import { render, staticRenderFns } from "./trove.vue?vue&type=template&id=4231e814&scoped=true&"
import script from "./trove.vue?vue&type=script&lang=js&"
export * from "./trove.vue?vue&type=script&lang=js&"
import style0 from "./trove.vue?vue&type=style&index=0&id=4231e814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4231e814",
  null
  
)

export default component.exports